import { render } from "./SelectAdvisors.vue?vue&type=template&id=74106b9f"
import script from "./SelectAdvisors.vue?vue&type=script&lang=js"
export * from "./SelectAdvisors.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__